var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 234.92 226.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-4 {\n        stroke-width: 1.99px;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        opacity: 0;\n        stroke: #000;\n        stroke-miterlimit: 1;\n      }\n\n      .cls-5 {\n        stroke-width: .8px;\n      }\n\n      .cls-6 {\n        stroke-width: .79px;\n      }\n\n      .cls-10 {\n        mix-blend-mode: overlay;\n        opacity: .49;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        fill: #f9f9f9;\n        fill-rule: evenodd;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.43,43.93c-34.99,39.39-31.55,99.85,7.67,135.03,39.23,35.18,99.4,31.76,134.39-7.63,34.99-39.4,31.56-99.85-7.66-135.03-18.16-16.28-40.82-24.3-63.38-24.3-26.17,0-52.22,10.78-71.01,31.93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1751.79,
    y1: -3983.87,
    x2: -1751.79,
    y2: -4175.13,
    gradientTransform: "translate(-1634.33 -3971.86) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99dfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#77b2e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9cace7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1a7e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.86,
    y: 8.15,
    width: 207.64,
    height: 199.09,
    transform: "translate(-5.92 6.56) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.99,
    y: 8.27,
    width: 207.52,
    height: 198.97,
    transform: "translate(-5.93 6.56) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.82,
    y: 10.59,
    width: 201.64,
    height: 194.54,
    transform: "translate(-5.93 6.62) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.12,27.49l-.34.02c-20.34,1.2-40.23,10.18-54.87,26.66-29.38,33.07-26.5,83.81,6.44,113.34,16.41,14.71,37.18,21.38,57.53,20.28l.46-.03c20.33-1.21,40.2-10.19,54.84-26.66,14.65-16.49,21.28-37.39,20.15-57.85l-.02-.3c-1.2-20.46-10.15-40.46-26.57-55.19-15.25-13.67-34.27-20.4-53.21-20.4-1.47,0-2.94.04-4.41.12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.64,
    y: 27.36,
    width: 159.82,
    height: 160.54,
    transform: "translate(-5.91 6.84) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.99,
    y: 8.27,
    width: 207.52,
    height: 198.97,
    transform: "translate(-5.93 6.56) rotate(-3.25)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 139.74,
    cy: 133.42,
    r: 75.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 5.88,
    y: 6.15,
    width: 223.15,
    height: 213.84,
    transform: "translate(-6.22 6.84) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.43,43.93c-34.99,39.39-31.56,99.84,7.67,135.03,39.23,35.18,99.4,31.76,134.39-7.63,34.99-39.4,31.56-99.86-7.67-135.03C141.6,1.13,81.43,4.54,46.43,43.93"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M49.72,46.73c-33.56,37.82-30.26,95.86,7.36,129.64,37.62,33.77,95.31,30.5,128.87-7.32,33.55-37.82,30.26-95.86-7.36-129.64C140.97,5.63,83.28,8.91,49.72,46.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.72,46.73c-33.56,37.82-30.26,95.86,7.36,129.64,37.62,33.77,95.31,30.5,128.87-7.32,33.55-37.82,30.26-95.86-7.36-129.64C140.97,5.63,83.28,8.91,49.72,46.73"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1599,
    height: 1227,
    transform: "translate(44.49 58.17) scale(.08)",
    xlinkHref: "../../../../../../Downloads/R3 Abbreviated 1.png"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.92,54.16c-29.38,33.07-26.5,83.81,6.43,113.34,32.94,29.52,83.44,26.66,112.83-6.41,29.37-33.07,26.49-83.81-6.43-113.34-32.94-29.52-83.44-26.66-112.83,6.41"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR3);
export default __webpack_public_path__ + "static/media/R3.d51f9a196e612248485dd30618ab4441.svg";
export { ForwardRef as ReactComponent };